var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sale-step" },
    [
      _c(
        "b-alert",
        {
          staticClass: "p-1 mb-2",
          attrs: { show: _vm.multiSale, variant: "warning" },
        },
        [
          _c("small", [
            _vm._v(_vm._s(_vm.$t("catalog.sale.multi_sale_warning"))),
          ]),
        ]
      ),
      _c("div", { staticClass: "sale-step-section" }, [
        _c(
          "h6",
          { staticClass: "sale-step-heading" },
          [
            _c("feather-icon", {
              staticClass: "mr-50",
              attrs: { icon: "DollarSignIcon", svgClasses: "w-4 h-4" },
            }),
            _vm._v(
              " " +
                _vm._s(
                  _vm.subscriptionPlan
                    ? _vm.$t("product.subscription_price")
                    : _vm.$t("catalog.sale.price")
                ) +
                " "
            ),
          ],
          1
        ),
        _c(
          "small",
          { staticClass: "text-muted d-block mb-1" },
          [
            _vm.subscriptionPlan
              ? [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("product.subscription_price_help", {
                          interval: (
                            _vm.subscriptionPlan.interval_label || ""
                          ).toLowerCase(),
                        })
                      ) +
                      " "
                  ),
                ]
              : [
                  _vm._v(
                    _vm._s(_vm.priceHint || _vm.$t("catalog.sale.price_hint"))
                  ),
                ],
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "sale-step-price" },
          [
            _c(
              "money",
              _vm._b(
                {
                  staticClass: "form-control required",
                  attrs: { id: "sale_price", value: _vm.localPrice },
                  on: { input: _vm.onPriceInput },
                  nativeOn: {
                    focus: function ($event) {
                      _vm.priceTouched = true
                    },
                  },
                },
                "money",
                _vm.moneyMask,
                false
              )
            ),
          ],
          1
        ),
        Number(_vm.price) === 0
          ? _c("small", { staticClass: "text-warning d-block mt-1" }, [
              _vm._v(" " + _vm._s(_vm.$t("catalog.sale.free_notice")) + " "),
            ])
          : _vm._e(),
        _vm.subscriptionPlan
          ? _c(
              "div",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-badge",
                  { attrs: { variant: _vm.gatewayStatus.variant } },
                  [_vm._v(_vm._s(_vm.gatewayStatus.label))]
                ),
                _vm.gatewayStatus.hint
                  ? _c(
                      "small",
                      {
                        staticClass: "d-block mt-1",
                        class: _vm.gatewayStatus.hintClass,
                      },
                      [_vm._v(" " + _vm._s(_vm.gatewayStatus.hint) + " ")]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.showPhotos
        ? _c(
            "div",
            { staticClass: "sale-step-section" },
            [
              _c(
                "h6",
                { staticClass: "sale-step-heading" },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "ImageIcon", svgClasses: "w-4 h-4" },
                  }),
                  _vm._v(" " + _vm._s(_vm.$t("catalog.sale.photos")) + " "),
                ],
                1
              ),
              _c("small", { staticClass: "text-muted d-block mb-1" }, [
                _vm._v(
                  _vm._s(_vm.photosHint || _vm.$t("catalog.sale.photos_hint"))
                ),
              ]),
              _vm.productId
                ? _c(
                    "vue-dropzone",
                    {
                      key: "dz-" + _vm.productId,
                      ref: "fileUploadZone",
                      staticClass: "sale-step-dropzone",
                      attrs: {
                        id: "sale_step_upload",
                        "use-font-awesome": true,
                        options: _vm.dropzoneOptions,
                        "use-custom-dropzone-options": true,
                        useCustomSlot: true,
                      },
                      on: {
                        "vdropzone-success": _vm.onUploadSuccess,
                        "vdropzone-error": _vm.onUploadError,
                        "vdropzone-queue-complete": _vm.onUploadComplete,
                      },
                    },
                    [
                      _c("div", { staticClass: "dropzone-custom-content" }, [
                        _c("h4", { staticClass: "dropzone-custom-title" }, [
                          _vm._v(_vm._s(_vm.$t("messages.drag_and_drop_file"))),
                        ]),
                        _c("div", { staticClass: "subtitle" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("messages.or_select_file_in_computer")
                            )
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.files.length
                ? _c(
                    "div",
                    { staticClass: "sale-step-photos" },
                    _vm._l(_vm.files, function (media) {
                      return _c(
                        "div",
                        { key: media.id, staticClass: "sale-step-photo" },
                        [
                          _vm.mediaUrl(media)
                            ? _c("img", {
                                attrs: {
                                  src: _vm.mediaUrl(media),
                                  alt: media.file_name,
                                },
                              })
                            : _c(
                                "div",
                                { staticClass: "sale-step-photo-fallback" },
                                [
                                  _c("feather-icon", {
                                    attrs: {
                                      icon: "FileIcon",
                                      svgClasses: "w-6 h-6",
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c(
                            "button",
                            {
                              staticClass: "sale-step-photo-remove",
                              attrs: {
                                type: "button",
                                title: _vm.$t("catalog.sale.remove_photo"),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmDelete(media)
                                },
                              },
                            },
                            [
                              _c("feather-icon", {
                                attrs: { icon: "XIcon", svgClasses: "w-4 h-4" },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("small", { staticClass: "text-muted d-block mt-1" }, [
                    _vm._v(_vm._s(_vm.$t("catalog.sale.no_photos"))),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _vm._t("default"),
      _c("div", { staticClass: "sale-step-section" }, [
        _c(
          "button",
          {
            staticClass: "sale-step-toggle",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                _vm.textsOpen = !_vm.textsOpen
              },
            },
          },
          [
            _c("feather-icon", {
              staticClass: "mr-50",
              attrs: {
                icon: _vm.textsOpen ? "ChevronDownIcon" : "ChevronRightIcon",
                svgClasses: "w-4 h-4",
              },
            }),
            _c("span", [_vm._v(_vm._s(_vm.$t("catalog.sale.texts_optional")))]),
          ],
          1
        ),
        _c("small", { staticClass: "text-muted d-block mb-1" }, [
          _vm._v(_vm._s(_vm.$t("catalog.sale.texts_hint"))),
        ]),
        _vm.textsOpen
          ? _c("div", { staticClass: "mt-1" }, [
              _vm.showDescription
                ? _c(
                    "div",
                    { staticClass: "w-full mb-2" },
                    [
                      _c("label", { staticClass: "text-sm pl-1" }, [
                        _vm._v(
                          _vm._s(_vm.$t("catalog.sale.description_advanced"))
                        ),
                      ]),
                      _c("ComplexEditor", {
                        attrs: { editor_data: _vm.description },
                        on: {
                          "update:editor_data": function ($event) {
                            return _vm.$emit("update:description", $event)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "w-full mb-2" },
                [
                  _c("label", { staticClass: "text-sm pl-1" }, [
                    _vm._v(_vm._s(_vm.$t("product.how_works"))),
                  ]),
                  _c("small", { staticClass: "text-muted d-block" }, [
                    _vm._v(_vm._s(_vm.$t("catalog.sale.how_works_hint"))),
                  ]),
                  _c("ComplexEditor", {
                    attrs: { editor_data: _vm.howWorks },
                    on: {
                      "update:editor_data": function ($event) {
                        return _vm.$emit("update:howWorks", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "w-full" },
                [
                  _c("label", { staticClass: "text-sm pl-1" }, [
                    _vm._v(_vm._s(_vm.$t("product.guidelines"))),
                  ]),
                  _c("small", { staticClass: "text-muted d-block" }, [
                    _vm._v(_vm._s(_vm.$t("catalog.sale.guidelines_hint"))),
                  ]),
                  _c("ComplexEditor", {
                    attrs: { editor_data: _vm.guidelines },
                    on: {
                      "update:editor_data": function ($event) {
                        return _vm.$emit("update:guidelines", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }